import React from 'react'
import * as mapPin from '../../../../images/icons/maps/icon-map-pin.png';
import { Marker } from "react-google-maps"
import MapCard from '../MapCard/MapCard.jsx'


export default ({ lat, lng, restaurant, activeInfoWindow, toggleInfoWindow }) => {


  const markerRef = React.createRef()

  const onMarkerClick = () => {
    toggleInfoWindow(restaurant.id)
  }

  return (
    <div className="c-searchMarkerWrapper" ref={markerRef}>
      <Marker 
        position={{ lat, lng }}
        icon={{
          url: mapPin,
          scaledSize: new window.google.maps.Size(25,39) 
        }}
        onClick={onMarkerClick}
      >
        {
          activeInfoWindow === restaurant.id && (
            <MapCard restaurant={restaurant} />
          )
        }
      </Marker>
    </div>
  )
}